import React, { useState } from 'react';
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { useTheme } from "../../context/ThemeContext";
import '../../user-pages/userpages.css'
import { toast } from 'react-toastify';
import { ResetPassword } from '../../../services/backendServices';
function ResetpasswordModal({ show, onClose }) {
    const { isDarkTheme } = useTheme();
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [currentPassword, setCurrentPassword] = useState("");
    const [showCurrentPassword, setShowCurrentpassword] = useState("");
    const [showNewPassword, setShowNewPassword] = useState("");
    const [showConfrimPassword, setShowConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false); // Track API call status
    // Validate Function
    const validateForm = () => {
        if (newPassword?.length < 6) {
            toast.error('Password must be at least 6 characters long.');
            return false;
        }
        if (newPassword !== confirmPassword) {
            toast.error('New password and confirm password do not match.');
            return false;
        }
        return true;
    }


    // Handle Reset Password Submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateForm()) {
            return;
        }
        const payload = {
            old_password: currentPassword?.trim(),
            new_password: newPassword?.trim(),
        }
        ResetPasswordApiCall(payload);
    };
    const ResetPasswordApiCall = async (Values) => {
        setIsLoading(true);
        try {
            const res = await ResetPassword(Values);
            if (res.status) {
                onClose();
                toast.success(res.msg);
            } else {
                toast.error(res.msg);
            }
        } catch (e) {
            console.error("Error Reset Password", e);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <Modal show={show} animation={true} size="nds" className={`${isDarkTheme && "dark-modal"} mt-5`}>
            <Modal.Header closeButton onClick={onClose} style={{ borderBottom: `1px solid ${isDarkTheme ? "#333" : "#ccc"}`, }}>
                <Modal.Title>Change Password</Modal.Title>
            </Modal.Header>
            <Modal.Body className={`p-10`}>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className='mb-2 position-relative' >
                        <Form.Label className={isDarkTheme ? "text-white mb-1" : "text-dark mb-1"} >Current Password</Form.Label>
                        <div className="position-relative">

                            <Form.Control
                                className={`${isDarkTheme ? "dark-form-control" : ""}`}
                                type={showCurrentPassword ? 'text' : 'password'}
                                placeholder="Enter Current Password"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                disabled={isLoading}
                                autoComplete="old-password"
                                required
                            />
                            <span onClick={() => setShowCurrentpassword(!showCurrentPassword)} style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#ffff' }}    >
                                {showCurrentPassword ? <i className='mdi mdi-eye-outline'></i> : <i className='mdi mdi-eye-off-outline'></i>}
                            </span>
                        </div>
                    </Form.Group>
                    <Form.Group className='mb-2 position-relative' >
                        <Form.Label className={isDarkTheme ? "text-white mb-1" : "text-dark mb-1"} >New Password</Form.Label>
                        <div className="position-relative">
                            <Form.Control
                                className={`${isDarkTheme ? "dark-form-control" : ""}`}
                                type={showNewPassword ? 'text' : 'password'}
                                placeholder="Enter New Password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                disabled={isLoading}
                                autoComplete="new-password"
                                required
                            />
                            <span onClick={() => setShowNewPassword(!showNewPassword)} style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#ffff' }}    >
                                {showNewPassword ? <i className='mdi mdi-eye-outline'></i> : <i className='mdi mdi-eye-off-outline'></i>}
                            </span>
                        </div>
                    </Form.Group>
                    <Form.Group className='mb-2 position-relative' >
                        <Form.Label className={isDarkTheme ? "text-white mb-1" : "text-dark mb-1"} >Confirm New Password</Form.Label>
                        <div className="position-relative">

                            <Form.Control
                                className={`${isDarkTheme ? "dark-form-control" : ""}`}
                                type={showConfrimPassword ? 'text' : 'password'}
                                placeholder="Confirm New Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                disabled={isLoading}
                                autoComplete="old-password"
                                required
                            />
                            <span onClick={() => setShowConfirmPassword(!showConfrimPassword)} style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#ffff' }}    >
                                {showConfrimPassword ? <i className='mdi mdi-eye-outline'></i> : <i className='mdi mdi-eye-off-outline'></i>}
                            </span>
                        </div>
                    </Form.Group>
                    <div className='d-flex align-items-center  justify-content-end gap-2 mt-3' >
                        <Button variant="danger" onClick={onClose} disabled={isLoading}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={isLoading}>
                            {isLoading ? (<i className='mdi mdi-loading'></i>) : ("Submit")}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>

        </Modal>
    );
}

export default ResetpasswordModal;
